import { Component } from '@angular/core';

@Component({
    selector: 'app-account-result-page',
    templateUrl: './account-result-page.component.html',
    styleUrls: ['./account-result-page.component.scss']
})
export class AccountResultPageComponent {}
